import { useQuery } from "@tanstack/react-query";
import { getDoctors } from "../services/doctorService";

export const useDoctors = (token?: string | null) => {
  return useQuery({
    queryKey: ["doctors"],
    queryFn: () => getDoctors(token as string),
    enabled: !!token,
    staleTime: 0,
    refetchInterval: 5000,
    refetchOnWindowFocus: true,
  });
};